import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private totalRequests = 0;

  constructor(private loaderService: LoaderService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // console.log('caught');
    //console.log(request);
      //provide the method name in lowercase
      var methodArray: Array<string> = ['getuser', 'waitingforcall', 'getupdate', 'getagentstatuses', 'isinboundcallconnected',
          'getcommunicationhistorysilent', 'getinternalcallinfo', 'istransfercancelled','rejectcall','getactionitempage','getexternalnumbersbyactivity',
          'getinboundstatus', 'getqueuecolumns', 'getsipcredentials', 'getqueues', 'releaselocks', 'setuserstatus', 'setcurrentqueue', 'getqueuecolums', 'getbasicagentstats',
          'getlocks', 'getagent', 'getcaselocks', 'getlivestatusbyidsilent', 'gettransfergroups', 'getgrouptransferstatus', 'getvoicemailcountbystatus',
          'dispositionrequiresinteraction', 'istestcallinprogress', 'getlivestatuses', 'getinboundcalls', 'getinboundstatus', '.json','requestedtimeoutextension','postcalltimedout', 'savecasenotes'
      ];
      var urls = request.url.toLowerCase().split('?');
      var methodfound = methodArray.some(r => urls[0].includes(r));//these methods are not required to show the loader
      // if (request.url.toLowerCase().lastIndexOf('/getuser') == -1  ) {
      if (!methodfound) {
          this.loaderService.display(true);
          this.totalRequests++;
      }
      // else {
      //     this.loaderService.display(false);
      // }
      
    return next.handle(request).pipe(
      finalize(() => {
        this.totalRequests--;
        setTimeout(() => {
          if (this.totalRequests == 0) {
            this.loaderService.display(false);
          }
        }, 1000);
      })
    );
  }
}
